export enum PROJECT_QV_TABS {
	overview = '_',
	comments = '__',
}
